import currentUserStorage from 'containers/services/security/current-user-storage';
import { get, isEmpty } from 'lodash';

export const PRIVILEGES = {
  ISOPENINGMANAGER: 'isOpeningManager',
  ISCOURTMANAGER: 'isCourtManager',
  ISCOURTMONITORINGMANAGER: 'isCourtMonitoringManager',
  ISMANAGER: 'isManager',
  ISPREOPENMANAGER: 'isPreOpenManager',
  ISCONSULTATIONMANAGER: 'isConsultationManager',
  ISTRANSACTIONMANAGER: 'isTransactionManager',
  ISJUDGEMENTARCHIVEMANAGER: 'isJudgementArchiveManager',
  ISPRIORITYCLAIMSMANAGER: 'isPriorityClaimsManager',
};

export const userHasPrivilege = (privilege: string) => {
  const privileges = get(currentUserStorage.get(), 'privileges');

  if (isEmpty(privileges)) return false;

  return privileges[
    privilege as
      | 'isOpeningManager'
      | 'isCourtManager'
      | 'isCourtMonitoringManager'
      | 'isConsultationManager'
      | 'isTransactionManager'
      | 'isJudgementArchiveManager'
      | 'isPriorityClaimsManager'
  ];
};
export const getUserInboxes = () => {
  const privileges = get(currentUserStorage.get(), 'privileges');
  return get(privileges, 'inboxes', []);
};

const userPrivileges = { PRIVILEGES, userHasPrivilege, getUserInboxes };

export default userPrivileges;
